const createCreditMapping = ({ token, creditMapping }, { creditRepo, observer }) => {
  creditRepo.createCreditMapping(
    { creditMapping, token },
    {
      success: (response) => {
        if (response.data.errors) {
          observer.failure(response.error)
          return
        }

        observer.success(response.data)
      },
      failure: (error) => {
        observer.failure(error)
      }
    }
  )
}

export default createCreditMapping
